import { UnauthorizedPage } from '@/components/UnauthorizedPage/UnauthorizedPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
});
